export default function (itemArray, key) {
  if (itemArray && Array.isArray(itemArray)) {
    return itemArray.map(function (item) {
      return item[key]
    }).join(', ')
  }
}
